<template>
    <div v-if="additionalNutritionTitle" class="text-xl text-link font-semibold pb-4">
        {{ additionalNutritionTitle }}
    </div>

    <div v-if="additionalNutritionTableData.length > 0" class="overflow-x-auto">
        <table class="table table-zebra max-w-md">
            <tbody>
                <tr v-for="(row, index) in additionalNutritionTableData" :key="index">
                    <td style="width: 75%;">{{ row[0] }}</td>
                    <td v-if="row[1]" style="width: 25%;">{{ row[1] }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";

const props = defineProps<{
    customFields?: object | undefined
}>()

const additionalNutritionData = ref(props.customFields?.additional_nutrition_values);

const isValidData = computed(() =>
    additionalNutritionData.value && additionalNutritionData.value.includes(":")
);

const additionalNutritionTitle = computed(() => (
    isValidData.value ? additionalNutritionData.value.split(":")[0] : "")
);

const additionalNutritionTableData = computed(() => {
    if (!isValidData.value) return [];

    return additionalNutritionData.value
        .split(":").slice(1).join(":")
        .split("||")
        .map(row => row.split("|").filter(cell => cell.trim() !== ""));
});
</script>